import React, { useState } from 'react'

import { useEffect, useRef } from 'react'

import request from '@function/ajax/request'

export default function PickerFetcher ({ onError, onResults, ...props })
{
	const model_ref = useRef();
	const search_ref = useRef();
	const init_ref = useRef();

	const { setVisibility, setLoading, searched, model } = props;
	
	const no_init_fetch = props['no-initial-fetch'] ? true : false;

	useEffect(function ()
	{
		const controller = new AbortController();

		if (props.cancel === true)
		{
			updateRefs();

			return;
		}

		if (model_ref.current === model && search_ref.current === searched)
		{
			setLoading(false);
			return;
		}

		if (no_init_fetch && !init_ref.current && !searched)
		{
			return;
		}

		init_ref.current = true;

		(async function ()
		{
			try
			{
				var response = await request(props.url)
				.config({ controller, keyword: 'action', min_req_time: 300 })
				.post(
				{
					model: model,
					searched: searched,
					custom: props.custom,
					exclude: props.exclude
				});
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				if (onResults) onResults([]);

				return onError
				? onError({ error: update.error })
				: console.error(update);
			}

			if (onResults) onResults(response?.data || []);

			setLoading(false);
			updateRefs();

			if (response?.data?.length && searched)
			{
				setVisibility(true);
			}
		})();

		return () => controller?.abort?.();

		function updateRefs ()
		{
			model_ref.current = model;
			search_ref.current = searched;
		}
	},
	[model, onError, onResults, searched, props.cancel, setVisibility, setLoading,
	props.custom, props.url, no_init_fetch]);

	return null;
}